import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

const confirmPasswordRequested = createAction("user/confirmpasswordrequested")
const confirmPasswordSent = createAction("user/confirmpasswordsent")
const confirmPasswordFailed = createAction("user/confirmpasswordfailed")

const sendInstructionRequested = createAction("user/sendinstructionrequested")
const sendInstructionSent = createAction("user/sendinstructionsent")
const sendInstructionFailed = createAction("user/sendinstructionfailed")

const verifyTokenRequested = createAction("user/verifytokenrequested")
const verifyTokenSent = createAction("user/verifytokensent")
const verifyTokenFailed = createAction("user/verifytokenfailed")

const initialState = {
    ...LOADING_INITIAL_STATE
}

const confirmPasswordReducer = createReducer(initialState, {

    [sendInstructionRequested.type]: (state) => {
        setRequested(state)
    },
    [sendInstructionSent.type]: (state) => {
        setReceived(state)
    },
    [sendInstructionFailed.type]: (state) => {
        setFailed(state)
    },
    [verifyTokenRequested.type]: (state) => {
        setRequested(state)
    },
    [verifyTokenSent.type]: (state) => {
        setReceived(state)
    },
    [verifyTokenFailed.type]: (state) => {
        setFailed(state)
    },
    [confirmPasswordRequested.type]: (state) => {
        setRequested(state)
    },
    [confirmPasswordSent.type]: (state) => {
        setReceived(state)
    },
    [confirmPasswordFailed.type]: (state) => {
        setFailed(state)
    }
})

export default confirmPasswordReducer

export const sendInstruction = (guestToken) =>
    api({
        url: "/user/send_instruction",
        method: "post",
        guestToken,
        onStart: sendInstructionRequested.type,
        onSuccess: sendInstructionSent.type,
        onError: sendInstructionFailed.type
    })
export const verifyToken = (token) =>
    api({
        url: `/user/verify_token/?token=${token}`,
        method: "get",
        onStart: verifyTokenRequested.type,
        onSuccess: verifyTokenSent.type,
        onError: verifyTokenFailed.type
    })
export const setPassword = (data) =>
    api({
        url: "/user/set_password",
        method: "post",
        data,
        onStart: confirmPasswordRequested.type,
        onSuccess: confirmPasswordSent.type,
        onError: confirmPasswordFailed.type
    })
